import { useCallback, useState } from "react";

// Liste filtrelerini sessionStorage'da saklar. Listeden detaya gidip geri
// dönünce (tarayıcı geri tuşu dahil) liste aynı filtre/aramayla açılır.
// sessionStorage sekmeye özel olduğu için sekme kapanınca temizlenir.

export function readPersistedFilters(storageKey) {
  try {
    const raw = sessionStorage.getItem(storageKey);
    return raw ? JSON.parse(raw) : null;
  } catch (_) {
    return null;
  }
}

export function writePersistedFilters(storageKey, value) {
  try {
    sessionStorage.setItem(storageKey, JSON.stringify(value));
  } catch (_) {
    // storage dolu/kapalıysa sessizce geç — kalıcılık best-effort
  }
}

/**
 * Öncelik sırası: override (deep-link) > sessionStorage > defaults.
 * @returns {[object, (updater) => void]} useState benzeri ikili
 */
export default function usePersistedFilters(storageKey, defaults, override = null) {
  const [value, setValue] = useState(() => {
    const initial = {
      ...defaults,
      ...(readPersistedFilters(storageKey) || {}),
      ...(override || {}),
    };
    if (override) writePersistedFilters(storageKey, initial);
    return initial;
  });

  const update = useCallback(
    (updater) => {
      setValue((prev) => {
        const next = typeof updater === "function" ? updater(prev) : updater;
        writePersistedFilters(storageKey, next);
        return next;
      });
    },
    [storageKey]
  );

  return [value, update];
}
